import { Button, Form, Space } from "antd";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import UserRolesBehaviorSelect from "@/components/UserRolesBehaviorSelect";
import UserRolesSubjectSelect from "@/components/UserRolesSubjectSelect";
import { useAddRole } from "@/hooks/queries/user";
import { useSidePanel } from "@/modules/side-panel";
import { Alert } from "@/ui/alert";

const { useForm } = Form;

const USER_ACCESS_FORM_ID = "UserAccessForm";

const UserAccess = ({ user }) => {
  const [form] = useForm();
  const { t } = useTranslation();
  const { closeSidePanel } = useSidePanel();

  const behavior = Form.useWatch("behavior", form);
  const mutation = useAddRole("users", user.id);

  useEffect(() => {
    form.resetFields(["subject"]);
  }, [behavior]);

  const onClose = () => {
    form.resetFields();
    closeSidePanel();
  };

  const onUpdate = ({ subject, behavior }) => {
    const role = {
      subject_id: subject?.value ?? null,
      behavior: behavior,
    };

    mutation.mutate(role, {
      onSuccess: () => {
        onClose();
      },
    });
  };
  return (
    <>
      <Form form={form} onFinish={onUpdate} id={USER_ACCESS_FORM_ID}>
        <UserRolesBehaviorSelect />
        <UserRolesSubjectSelect behavior={behavior} />
      </Form>
      <Alert
        display={mutation.isError}
        closable={{ afterClose: () => mutation.reset() }}
      />
      <Space>
        <Button onClick={onClose}>{t("global:cancel")}</Button>
        <Button
          loading={mutation.isPending}
          type="primary"
          htmlType="submit"
          form={USER_ACCESS_FORM_ID}
        >
          {t("global:add")}
        </Button>
      </Space>
    </>
  );
};

UserAccess.propTypes = {
  user: PropTypes.object.isRequired,
};

export default UserAccess;
